import { Stack, styled } from '@mui/material';

export const ContentContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.opacity[50],
  borderRadius: theme.spacing(8),
  backdropFilter: 'blur(48px)',
  padding: theme.spacing(6),
  height: '100%',
}));
